function handleSticky() {
 
  const stickyWrapper = document.querySelector('.js-productColumnStickyWrapper');
  const stickyElement = document.querySelector('.js-productColumnSticky');
  const accordions = document.querySelectorAll(".js-productAccordionLabel");

  if (!stickyWrapper || !stickyElement) return;

  let innerHeight = window.innerHeight;
  let wrapperRect = stickyWrapper.getBoundingClientRect();
  let elementRect = stickyElement.getBoundingClientRect();
  let lastScrollY = window.scrollY;
  let wrapperHeight = wrapperRect.height;//wrapperの高さ
  let upFlag = false;
  let downFlag = false;
  let upCount = 0;
  let upStart = 0;
  let downStart = 0;
  let wrapperPaddingTop = 188;


  //値の更新用
  const update=()=>{
    innerHeight = window.innerHeight;
    elementRect = stickyElement.getBoundingClientRect();
  }

  function raf(){
    update()
    requestAnimationFrame(raf);
  }
  raf()

  //下から上へスクロールした時に付与するスタイル
  const addBottomToTopStyle =()=>{
    stickyElement.style.position = "sticky";
    stickyElement.style.top = `188px`; 
    stickyElement.style.right = "8rem";
  }
  //上から下へスクロールした時に付与するスタイル
  const addTopToBottomStyle=()=>{
    stickyElement.style.position = "sticky";
   //stickyElement.style.top = `-${elementRect.height / 2}px`;
   stickyElement.style.top = `-${(elementRect.height - innerHeight * 0.95)}px`;
  }
  //アコーディオンクリックで高さが変動するので、値を更新
  // accordions.forEach(el=>{
  //   el.addEventListener("click",()=>{
  //     setTimeout(() => {
  //       update()
  //     }, 500);
  //   })
  // })


  /*--------------------------------
  * スクロールイベント本体
  *----------------------------*/
  const scrollEvents=()=>{
     const scrollY = window.scrollY;
    const isScrollDirection = scrollY > lastScrollY ? "down" : "up";

    if(scrollY == 0) {
      downFlag = false; 
      stickyElement.style.position = "static";
    }


    if(isScrollDirection == "down") {
      /*---------------
      * DOWN
      --------------------*/
      if(stickyElement.style.position == "relative") {
      
        if(downStart != 0) {
          const diff = downStart - scrollY;
  
          // if(Math.abs(diff) > (elementRect.height) * 0.5 + 100) {
          //   addTopToBottomStyle()
          //   downStart = 0;
          // }
          if(Math.abs(diff) > elementRect.height - innerHeight * 0.95 + wrapperPaddingTop) {
            addTopToBottomStyle()
            downStart = 0;
          }

          
          
        }

      } else if(!downFlag && stickyElement.style.position == "sticky") {
        stickyElement.style.position = "relative";
        stickyElement.style.top = `${scrollY}px`; 
        stickyElement.style.right = "auto"; 
      
        downStart = scrollY;
        downFlag = true;

      } else {

      downFlag = true;
      downStart = 0;
      //固定の親要素
      stickyWrapper.classList.add('is-fixed-bottom')

      //固定本体
      addTopToBottomStyle()

      //upCount初期化
      upCount = 0;
      
      }

      //上にスクロールしている最中に、下にスクロールされた時、スタート地点より下に行った場合クラス付与
      const check = elementRect.height > innerHeight*2 ?  upStart < scrollY - wrapperPaddingTop*2 : upStart < scrollY + wrapperPaddingTop;
      if(check) {
        addTopToBottomStyle()
      }



      if(downStart != 0) {
        // if(downStart + elementRect.height / 2 < scrollY) {
        //   addTopToBottomStyle()
        //   downStart = 0;
        // }

      }


    } else {
      /*---------------
      * UP
      --------------------*/
      downFlag = false;
        if(scrollY != 0) {
      if(scrollY < wrapperRect.height - innerHeight) {
        upCount++;

        //[スタート地点 - 現在のスクロール位]で、どのくらいスタート地点から戻ったか判定し、処理を実行
        if(upStart != 0) {
          const diff = upStart - scrollY;
       
          if(Math.abs(diff) > (elementRect.height) * 0.5 + wrapperPaddingTop) {
            addBottomToTopStyle()
          }
        }

        //コンテナー最下部前に上部へスクロールした時に一度だけ発火
        if(upCount == 1) {
          upStart = scrollY;//上部に戻り始めたスタート位置
          stickyElement.style.position = "relative";
          stickyElement.style.top = `${scrollY - elementRect.height*0.5 - wrapperPaddingTop}px`;
          
          stickyElement.style.right = "auto"; 
        }
      
      } else {
        if(scrollY != 0) {
        upCount = 1;
        upStart = 0;
        addBottomToTopStyle()
        }
      }
    }
  }
    // スクロール位置を更新
    lastScrollY = scrollY;
  }


  /**
  * イベント
  **/
  window.addEventListener('scroll',scrollEvents);
  window.addEventListener("resize",update);
 
}
window.addEventListener('DOMContentLoaded', handleSticky);
